import {override} from 'mobx';
import {AutoAnimation} from "../../../../../infrastructure/models/animation/auto-animation";
import {MatchBreakTimeEndedAnimationSetModel} from "../../../../../infrastructure/models/animation/game/animation-set-models/goal/match-break-time-ended-animation-set-model";
import {ANIMATION_TIMES} from "../../../../../core/consts";

export class GameCenterHeaderMatchBreakTimeEndedAnimationSetModel extends MatchBreakTimeEndedAnimationSetModel {
  duration: Number;

  constructor(animation) {
    super(animation);

    this.duration = ANIMATION_TIMES.GAME_CENTER.generalAnimationTime;
  }

  @override get statusContainer(): AutoAnimation {
    const enterAnimation: String = 'scale-up-center-infinite';
    const mainAnimation: String = 'scale-up-center-infinite';
    const leaveAnimation: String = 'scale-up-center-infinite';

    const container = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));

    return container;
  }
}
